import React from 'react';
import { Icon } from 'antd';

const MeSpinIcon = () => (
    <Icon type="loading" style={{ fontSize: 50, color: '#D05000' }} spin />
);

export default MeSpinIcon;



// WEBPACK FOOTER //
// ./src/components/MeSpinIcon.jsx